import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_EVENTO_TIPO_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeEventoTipoListAction,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const retrieveEventoTipoListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_EVENTO_TIPO_LIST),
    map(() => ({
      page: 1,
      pageSize: rootConfig.populateFields,
      order: [['nome', 'asc']],
    })),
    // tap(p => console.log(`[epic ${RETRIEVE_EVENTO_TIPO_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ eventoLoader: true })),
        of(setListConfigAction({ role: body })),
        defer(() =>
          from(
            request({
              path: `eventoTipo/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_EVENTO_TIPO_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeEventoTipoListAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_EVENTO_TIPO_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ eventoLoader: false }))
      );
    })
  );

export default retrieveEventoTipoListEpic;
